import { render, staticRenderFns } from "./dettaglioNuoto.vue?vue&type=template&id=2e1f730b"
import script from "./dettaglioNuoto.vue?vue&type=script&lang=js"
export * from "./dettaglioNuoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports